/**
 * Load the main stylesheet.
 *
 * Stylesheet will be built and extracted to CSS using Webpack.
 */
import style from '../scss/style.scss';
// import style from '../less/style.less';

export default style;
